<script setup>
import { onMounted, ref } from 'vue';
import { useFelixBagAuxStore, useGlobalStateStore } from '../../../store';
import requestApi from '@/utils/requestApi'

import ModalConfirmacao from './components/ModalConfirmacao.vue';
const felixBagAuxStore = useFelixBagAuxStore();
const globalStateStore = useGlobalStateStore();

const showModalConfirmacao = ref(false)
const comentario = ref('')

function confirmarClicked() {
  showModalConfirmacao.value = true;
}

onMounted(() => {
  felixBagAuxStore.pauseAfter(1000)
});


function iniciarAcolhimento() {
  let acolhimento = {
    name: 'acolhimento',
    title: 'Estamos com você',
    img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/250edb9e-a7e0-4a6b-bc90-01dbce5df767.svg',
    text: "Estamos com você"
  }
  requestApi({
    url: `/v2/vivo_integration/video/${process.env.VUE_APP_VIDEO_ID}/user/${window.ovmConfig.env['CPF']}/email_colaborador_acionou_mudanca`,
    method: 'POST',
    headers: {
      BCS: globalStateStore.uuid,
      'Content-Type': 'application/json',
    },
    data: {
      "message": "Algo inesperado aconteceu"
    }
  }
  ).then(() => {
    felixBagAuxStore.saveEvent('interromper', 'form_submit', comentario.value)
    globalStateStore.globalState.selectedData.profile = acolhimento
    felixBagAuxStore.showInteractive("trilha-de-acolhimento")
    felixBagAuxStore.hideInteractive("interromper")
  })
  
}

function close() {
  felixBagAuxStore.hideInteractive("interromper")
  felixBagAuxStore.showInteractive('menu-principal')
}

</script>

<template>
  <div id="interromper">
    <div class="header">
      <v-btn @click="close()" variant="text" class="close">
        <img
          src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/f150a967-b846-491c-84e6-eb612ca40e3e.svg"
          alt="">
      </v-btn>
    </div>

    <p class="interromper-title">Algo inesperado aconteceu! <br> Preciso interromper tudo.</p>

    <img style="width: 60%;"
      src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/ee9abc96-e81d-4ff0-b8cd-bfe8bf3bcbb0.svg"
      alt="">
    <div style="width: 85%;">
      <p class="label">Qual o motivo da interrupção?*</p>
      <v-textarea v-model="comentario" variant="outlined" rows="3" density="compact" no-resize
      ></v-textarea>
    </div>

    <v-btn @click="confirmarClicked" style="width: 85%;" color="#660099" variant="flat"
      class="text-none">Confirmar</v-btn>
  </div>

  <ModalConfirmacao v-if="showModalConfirmacao" @close-modal="showModalConfirmacao = false"
    @iniciar-acolhimento="iniciarAcolhimento" />
</template>

<style scoped>
#interromper {
  width: 100%;
  height: 90%;
  position: absolute;
  top: 0;
  z-index: 4;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
}

.header {
  width: 100%;
  height: 10%;
  background-color: #BC4AFF;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.interromper-title {
  color: #464646;
  font-weight: bold;
}

.label {
  font-size: 13px;
  text-align: start;
}
</style>